import { render, staticRenderFns } from "./ConsumptionDataExchangeAllpas.vue?vue&type=template&id=2987c56b&lang=pug&"
import script from "./ConsumptionDataExchangeAllpas.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeAllpas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports